var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-6 col-lg-4" },
      [
        _vm.title.length > 0
          ? _c("label-control", {
              staticClass: "col-form-label",
              attrs: { title: _vm.title, forElement: _vm.$attrs.id }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-6 col-lg-4 mt-1" }, [
      _c("div", { staticClass: "input-group mb-3" }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selected,
                expression: "selected"
              }
            ],
            staticClass: "custom-select",
            attrs: { name: _vm.$attrs.id, id: _vm.$attrs.id },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selected = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c(
              "option",
              { attrs: { selected: "" }, domProps: { value: null } },
              [_vm._v(_vm._s(_vm.$t("Selection.Choose")))]
            ),
            _vm._v(" "),
            _vm._l(_vm.periods, function(period) {
              return _c(
                "option",
                {
                  attrs: { title: period.name },
                  domProps: { value: period.data }
                },
                [_vm._v("\n          " + _vm._s(period.name) + "\n        ")]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-group-append" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.top.center",
                  value: { content: _vm.$t(_vm.title) },
                  expression: "{ content: $t(title) }",
                  modifiers: { top: true, center: true }
                }
              ],
              staticClass: "btn btn-secondary right col-auto",
              attrs: {
                type: "button",
                id: "period-select",
                "aria-label": _vm.$t(_vm.title)
              },
              on: {
                click: function($event) {
                  return _vm.select()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-file-import fa-lg" })]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }